import BaseApi, { BaseApiParams } from 'api/baseApi';
import { BatchTemplate } from 'core/model';

const batchTemplateApi = {
  getAll: (params: BaseApiParams) =>
    BaseApi.get<{ batchTemplates: BatchTemplate[] }>(`batchtemplate`, params),
};

export default batchTemplateApi;
